import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';

export const TemplateBarChart: Panel = {
    id: 'bar-chart',
    name: 'Bar Chart - Legacy',
    description: '',
    tags: ['Standard', 'Bar Chart', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_bar_chart',
        children: [
            {
                type: 'barChart',
                id: '1',
                name: 'Bar Chart',
                useGlobalTimePeriod: true,
                useGlobalTranslate: true,
                translationLanguage: null,
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 10,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.topicName },
                                INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                                PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                                BENCHMARKING: { dimensionName: 'BRAND_ID' }, //BENCHMARKING_ACCOUNT_ID
                                PAID: { dimensionName: 'accountIds' },
                                ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                                TWITTER: { dimensionName: 'TRENDING_TOPIC' },
                                RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                                STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                                COMMUNITY: { dimensionName: 'AUDIENCE_ACTIVITY_TYPE' },
                                SAM: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                                AUDIENCE_ACTIVITY: {
                                    source: ListeningDimensions.account,
                                    dimensionName: 'ACCOUNT_ID',
                                },
                                // UNIFIED_ANALYTICS_REPORTING_ENGINE : { dimensionName: ""}
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    titleText: 'Bar Chart',
                    enabled: true,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    orientation: 'vertical',
                    labelSize: 50,
                    metricValueSize: 50,
                    metricPercentChangeSize: 17,
                    metricNameSize: 15,
                    highlightPercentChange: false,
                    showMetricValue: true,
                    showYAxis: false,
                    showMetricName: true,
                    showMetricChange: false,
                    showSentiment: false,
                    xAxis: {
                        enabled: false,
                        label: {
                            enabled: true,
                            size: 50,
                            padding: 0,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                enabled: false,
                                size: 50,
                                numberFormat: '1.2k',
                                timeFormat: 'ddd ha',
                                angle: 0,
                            },
                            line: {
                                enabled: true,
                            },
                        },
                    },
                    yAxis: {
                        enabled: false,
                        label: {
                            enabled: true,
                            size: 50,
                            padding: 0,
                        },
                        ticks: {
                            enabled: true,
                            label: {
                                enabled: false,
                                size: 50,
                                numberFormat: '1.2k',
                                timeFormat: 'ddd ha',
                            },
                            line: {
                                enabled: false,
                            },
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                        optionDefaults: {
                            labelEnable: true,
                            showMetricName: true,
                            showMetricValue: true,
                            showMetricChange: false,
                            showTimeRemainder: true,
                            showYAxis: true,
                            xAxis: {
                                enabled: false,
                                label: {
                                    enabled: true,
                                    size: 50,
                                    padding: 20,
                                },
                                ticks: {
                                    enabled: true,
                                    label: {
                                        enabled: false,
                                        size: 50,
                                        numberFormat: '1.2k',
                                        timeFormat: 'ddd ha',
                                    },
                                    line: {
                                        enabled: true,
                                    },
                                },
                            },
                            yAxis: {
                                enabled: false,
                                label: {
                                    enabled: true,
                                    size: 50,
                                    padding: 20,
                                },
                                ticks: {
                                    enabled: true,
                                    label: {
                                        enabled: false,
                                        size: 50,
                                        numberFormat: '1.2k',
                                        timeFormat: 'ddd ha',
                                    },
                                    line: {
                                        enabled: false,
                                    },
                                },
                            },
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                        limit: 6,
                        metricNameSize: 20,
                        labelSize: 50,
                    },
                },
            },
        ],
    },
};
